import { NgTemplateOutlet } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { input, Component, InputSignal, TemplateRef, ContentChild } from '@angular/core';

import { SvgIconComponent } from '@/app/shared/components/ui/svg-icon/svg-icon.component';
import { MenuItemInterface } from '@/app/shared/components/common/sidebar-menu/Interfaces/menu-item.interface';

@Component({
  selector: 'app-sidebar-menu',
  imports: [RouterLinkActive, SvgIconComponent, RouterLink, NgTemplateOutlet],
  templateUrl: './sidebar-menu.component.html',
  styleUrl: './sidebar-menu.component.scss',
})
export class SidebarMenuComponent {
  public readonly type = input<string>('main');

  public items: InputSignal<MenuItemInterface[]> = input.required<MenuItemInterface[]>();

  @ContentChild('menuItemTemplate')
  protected menuItemTemplate?: TemplateRef<any>;
}
